import React from "react"

export default({errors}) => (
	<div className="app-form-errors">
    {errors.length ? errors.map(error => <div key={`form-errors-${error.key}`}>{error.key}</div>) : false}
  </div>
)